import React from "react";
import { Control, Controller, DeepMap, FieldError, RegisterOptions } from "react-hook-form";
import PlainDatePicker, { PlainDatePickerProps } from "./InspectionDatePicker";

interface ControlledPlainDatePickerProps {
  name: string;
  control: Control;
  rules?: Exclude<RegisterOptions, "valueAsNumber" | "valueAsDate" | "setValueAs">;
  errors?: DeepMap<Record<string, string>, FieldError>;
  datePickerProps?: Omit<PlainDatePickerProps, "value" | "onChange">;
}
export function ControlledPlainDatePicker({
  name,
  control,
  errors,
  rules,
  datePickerProps,
}: ControlledPlainDatePickerProps) {
  const fieldError = errors?.[name];
  const errorMessage = fieldError ? fieldError.message : "";
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ value, onChange }) => {
        return <PlainDatePicker {...datePickerProps} value={value} onChange={onChange} errorMessage={errorMessage} />;
      }}
    />
  );
}
